import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { IoDownloadOutline } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router-dom';
import useWebSocket from 'react-use-websocket';
import { icons } from '~/assets';
import STATES from '~/assets/mocks/states.json';
import Button from '~/components/button';
import CardView from '~/components/cartView';
import Checkbox from '~/components/checkbox';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Grid from '~/components/grid';
import Input, { MaskTypes } from '~/components/input';
import Loading from '~/components/loading';
import PictureCard from '~/components/pictureCard';
import Select from '~/components/select';
import TableList from '~/components/tableList';
import TableOCR from '~/components/tableOCR';
import TextArea from '~/components/textarea';
import TitleApp from '~/components/title';
import { IReducers } from '~/contexts/proposal';
import { useProposal } from '~/hooks/contexts/useProposal';
import { useUserRole } from '~/hooks/contexts/useUserRole';
import useApi, { ApiMethod } from '~/hooks/useApi';
import { IListColumn } from '~/models/listCol';
import {
  IProposal,
  IProposalResult,
  IProposalResumeLocationState,
  IProposalT,
  IReference,
  IReferenceII,
  IResponseProposalConvenio,
} from '~/models/proposal';
import ProposalReason from '~/models/proposal-reason';
import PropostaContatoReferencia from '~/models/proposta-contatos-ref';
import ProposalComplPayload from '~/services/credit-table/proposal/compl/payload';
import IResponseDefaultError from '~/services/default-error/response';
import endpoints from '~/services/endpoints';
import IResponseGetUserDocuments from '~/services/files/getUserDocuments/response';
import { GetOperatorsResponse } from '~/services/report/requestReport/response';
import Termos from '~/services/terms';
import Constants from '~/utils/constants';
import { setFormState } from '~/utils/form';
import { cpfMask, currencyMask, phoneMask } from '~/utils/masks';
import { ProposalStatus } from '~/utils/proposal-status';
import {
  emailValidator,
  IValidators,
  socialNameValidator,
  ValidatorsNames,
} from '~/utils/validators';
import { Label } from '~/views/HomeDash/styles';
import {
  CertifaceMessage,
  CertifaceTitle,
  UnicoMessage,
  UnicoTitle,
} from './components/CertifaceMessage';
import { ItemDialogReasonDivider } from './components/DialogReasonComponents';
import ProposalReference from './components/ProposalReference';
import ProposalReferenceII from './components/ProposalReferenceII';
import ProposalResult from './components/ProposalResult';
import ProposalResultSPC from './components/ProposalResultSPC';
import ReasonDialogItem from './components/ReasonDialogItem';
import * as St from './styles';

interface IErrors {
  parecer: string;
  valorLimiteSenff: string;
}

interface IRemakeProposalRanson {
  listaMotivosRefazer: IRemakeProposalRansonItem[];
}

interface IRemakeProposalRansonItem {
  descricao?: string;
  id?: string;
  idMotivo?: number;
}

interface Form {
  tValorLimiteSenff?: string;
}

interface ISearchOCRProposal {
  campos: {
    title: string;
    value: string;
  }[];
}

interface ITransferHistoryResponseItem {
  responsavelAnteriorNome?: string;
  novoResponsavelNome?: string;
  usuarioExecutorNome?: string;
  dataTransferencia?: string;
  motivo?: string;
}

const transferHistoryHeader = [
  {
    id: 1,
    value: 'Operador de Venda Inicial',
    maxChar: 24,
  },
  {
    id: 2,
    value: 'Operador de Venda Atual',
    maxChar: 24,
  },
  {
    id: 3,
    value: 'Responsável pela alteração',
    maxChar: 24,
  },
  {
    id: 4,
    value: 'Data ocorrência',
    maxChar: 18,
  },
  {
    id: 5,
    value: 'Motivo',
    maxChar: 28,
  },
];

const DetailProposalCT = (): JSX.Element => {
  const [dialogMessageStatus, setDialogMessageStatus] = useState(false);
  const [dialogApproveStatus, setDialogApproveStatus] = useState(false);
  const [dialogRefuseStatus, setDialogRefuseStatus] = useState(false);
  const [dialogIsOpenSave, setDialogIsOpenSave] = useState(false);
  const [dialogIsOpenSaveR, setDialogIsOpenSaveR] = useState(false);
  const [dialogReasonShow, setDialogReasonShow] = useState(false);
  const [dialogError, setDialogError] = useState(false);
  const [dialogClientSolicitation, setDialogClientSolicitation] = useState(
    false,
  );
  const [dialogRemakeProposalIsOpen, setDialogRemakeProposal] = useState(false);
  const [dialogErrorMessage, setDialogErrorMessage] = useState('');
  const [dialogCancelProposal, setDialogCancelProposal] = useState(false);
  const [dialogCancelProposalSucess, setDialogCancelProposalSucess] = useState(
    false,
  );
  const [userAuthorized, setUserAuthorized] = useState(false);
  const [operador, setOperador] = useState([]);
  const [selectedOperadorTransfer, setSelectedOperadorTransfer] = useState('');
  const [dialogTransferOpen, setDialogTransferOpen] = useState(false);
  const [dialogTransferConfirmOpen, setDialogTransferConfirmOpen] = useState(
    false,
  );
  const [dialogTransferHistoryOpen, setDialogTransferHistoryOpen] = useState(
    false,
  );
  const [transferHistoryLoading, setTransferHistoryLoading] = useState(false);
  const [transferHistoryList, setTransferHistoryList] = useState<
    IListColumn[][]
  >([]);

  const [dialogMessage, setDialogMessage] = useState('');
  const [dialogMessageGoBack, setDialogMessageGoBack] = useState(false);
  const [reasonRemakeProposal, setReasonRemakeProposal] = useState(-1);
  const [errorReasonRemakeProposal, setErrorReasonRemakeProposal] = useState(
    '',
  );
  const [othersReasonRemakeProposal, setOthersReasonRemakeProposal] = useState(
    '',
  );
  const [motivo, setMotivo] = useState('');
  const [parecer, setParecer] = useState('');
  const [proposalSPC, setProposalSPC] = useState<IProposal>({} as IProposal);
  const [
    proposalConvenio,
    setProposalConvenio,
  ] = useState<IResponseProposalConvenio>({} as IResponseProposalConvenio);
  const [diaVenc, setDiaVenc] = useState('');
  const [errors, setErrors] = useState<IErrors>({} as IErrors);
  const [validationErrors, setValidationErrors] = useState({} as IValidators);
  const [form, setForm] = useState<Form>({
    tValorLimiteSenff: '0,00',
  });

  const { state } = useLocation<{
    id: string;
    status: string;
    origem: string;
  }>();

  const history = useHistory();
  const {
    proposal,
    proposalResult,
    reference,
    referenceII,
    addReference,
    addReferenceII,
  } = useProposal();

  const { userRoles, hasAnyRole } = useUserRole();

  const [hasReference, setHasReference] = useState(false);
  const [hasReferenceII, setHasReferenceII] = useState(false);

  const [proposalT, setProposal] = useState<IProposalT>({
    proposal,
  } as IProposalT);

  const [, setProposalResult] = useState<IProposalResult>({
    proposalResult,
  } as IProposalResult);

  const [referenceT, setReference] = useState<IReference>({
    reference,
  } as IReference);

  const [referenceIIT, setReferenceII] = useState<IReferenceII>({
    referenceII,
  } as IReferenceII);

  const [reasons, setReasons] = useState<ProposalReason[]>([]);

  const [remakeRanson, setRemakeRanson] = useState<IRemakeProposalRansonItem[]>(
    [],
  );

  const RequestUserDocuments = useApi<IResponseGetUserDocuments>(
    `${endpoints.consult.searchUserDocuments}${state?.id}`,
    ApiMethod.GET,
  );

  const RequestProposalSPC = useApi<IProposal>(
    endpoints.consult.searchProposalSPC.replace('PARAM_ID_PROPOSTA', state?.id),
    ApiMethod.GET,
  );

  const GETSearchOCRProposal = useApi<ISearchOCRProposal>(
    endpoints.consult.getSearchOCRProposal.replace(
      'PARAM_ID_PROPOSTA',
      state?.id,
    ),
    ApiMethod.GET,
  );

  /**
   * Request utilizada quando a proposta é do tipo convenio.
   */
  const RequestProposalConvenio = useApi<IProposal>(
    endpoints.consult.getDataProposalConvenio.replace(
      'PARAM_ID_PROPOSTA',
      state?.id,
    ),
    ApiMethod.GET,
  );

  const RequestRemakeProposalRanson = useApi<IRemakeProposalRanson>(
    endpoints.consult.searchRemakeProposalRanson,
    ApiMethod.GET,
  );

  const RequestRemakeProposal = useApi<any>(
    endpoints.consult.searchRemakeProposal.replace(
      'PARAM_ID_PROPOSTA',
      state?.id,
    ),
    ApiMethod.POST,
  );

  const apiToAssign = useApi<IResponseDefaultError>(
    endpoints.consult.toAssign.replace('PARAM_ID_PROPOSTA', state?.id),
    ApiMethod.PUT,
  );

  const apiToUnassign = useApi<IResponseDefaultError>(
    endpoints.consult.toUnassign.replace('PARAM_ID_PROPOSTA', state?.id),
    ApiMethod.PUT,
  );

  const apiRefuse = useApi<PropostaContatoReferencia[]>(
    endpoints.register.proposalRefuse.replace('PARAM_ID_PROPOSTA', state?.id),
    ApiMethod.PUT,
    {
      motivoStatus: 1,
    },
  );

  const POSTReferenceIIAPI = useApi<IProposal>(
    `${endpoints.register.proposalReference}/${proposalSPC?.idProposta}`,
    ApiMethod.PUT,
  );

  const POSTReferenceAPI = useApi<IProposal>(
    `${endpoints.register.proposalReference}/${proposalSPC?.idProposta}`,
    ApiMethod.PUT,
  );

  const POSTProposalAPI = useApi<IProposal>(
    `${endpoints.update.proposal}`,
    ApiMethod.PUT,
  );

  const PUTCancelProposal = useApi(
    endpoints.register.cancelProposal.replace('PARAM_ID_PROPOSTA', state?.id),
    ApiMethod.PUT,
  );

  const apiKeepProposal = useApi(
    endpoints.register.proposalKeepAnalysis.replace(
      'PARAM_ID_PROPOSTA',
      state?.id,
    ),
    ApiMethod.PUT,
  );

  const apiApproveProposal = useApi<any>(
    `${endpoints.register.proposalApprove}`,
    ApiMethod.POST,
  );

  const POSTCTproposalApproveNew = useApi<any>(
    `${endpoints.register.POSTCTproposalApproveNew}`,
    ApiMethod.POST,
  );

  const RequestGetOperators = useApi(
    endpoints.report.getProfileOperators,
    ApiMethod.GET,
  );

  const RequestPutTransferOperator = useApi(
    `${endpoints.register.putTransferOperator}`.replace(
      'PARAM_ID_PROPOSTA',
      state?.id,
    ),
    ApiMethod.PUT,
  );

  const RequestGetTransferHistory = useApi(
    endpoints.register.getTransferHistory.replace(
      'PARAM_ID_PROPOSTA',
      state?.id,
    ),
    ApiMethod.GET,
  );

  const getOperador = useCallback(async () => {
    const response = await RequestGetOperators.callApi();

    if (response.status === 200) {
      const data = response.data as GetOperatorsResponse[];

      const getOperadores = data.map(({ nome, id }) => ({
        id,
        value: nome,
      }));

      setOperador(getOperadores);
    }
  }, [RequestGetOperators && ProposalStatus.APROVADA_P1]);

  const fetchTransferHistory = useCallback(async () => {
    try {
      setTransferHistoryLoading(true);

      const response = await RequestGetTransferHistory.callApi();
      const items = [];
      const transferHistoryData = response.data as
        | ITransferHistoryResponseItem[]
        | {
            transferencias?: ITransferHistoryResponseItem[];
            historicoTransferencias?: ITransferHistoryResponseItem[];
            listaTransferencias?: ITransferHistoryResponseItem[];
          };

      const transferData = Array.isArray(transferHistoryData)
        ? transferHistoryData
        : transferHistoryData?.transferencias ||
          transferHistoryData?.historicoTransferencias ||
          transferHistoryData?.listaTransferencias ||
          [];

      transferData.forEach((i) => {
        const item: IListColumn[] = [
          {
            id: 1,
            value: i.responsavelAnteriorNome || '-',
            textAlign: 'center',
            maxChar: 24,
          },
          {
            id: 2,
            value: i.novoResponsavelNome || '-',
            maxChar: 24,
            textAlign: 'center',
          },
          {
            id: 3,
            value: i.usuarioExecutorNome || '-',
            maxChar: 24,
            textAlign: 'center',
          },
          {
            id: 4,
            value: i.dataTransferencia
              ? moment(i.dataTransferencia).format('DD/MM/YYYY')
              : '-',
            maxChar: 15,
            textAlign: 'center',
          },
          {
            id: 5,
            value: i.motivo || '-',
            maxChar: 28,
            textAlign: 'center',
          },
        ];

        items.push(item);
      });

      setTransferHistoryList(items);
    } catch {
      // ignore error
    } finally {
      setTransferHistoryLoading(false);
    }
  }, []);

  useEffect(() => {
    if (dialogTransferHistoryOpen) {
      fetchTransferHistory();
    }
  }, [fetchTransferHistory, dialogTransferHistoryOpen]);

  const putTransferOperator = useCallback(async () => {
    const user = JSON.parse(localStorage.getItem('@NovaEra:user') || '{}');
    const response = await RequestPutTransferOperator.callApi({
      novoResponsavelId: selectedOperadorTransfer,
      usuarioExecutorId: user?.id,
      usuarioExecutorNome: user?.nomeTitular,
      motivo,
    });

    if (response.status === 200) {
      setDialogMessageStatus(true);
      setDialogMessage('Proposta transferida com sucesso!');
      setDialogMessageGoBack(true);
    } else {
      setDialogMessageStatus(true);
      setDialogMessage('Erro ao transferir proposta!');
      setDialogMessageGoBack(false);
    }
  }, [
    RequestPutTransferOperator,
    proposalSPC,
    operador,
    selectedOperadorTransfer,
    motivo,
  ]);

  const isSenff = state?.origem === 'SENFF';
  const isPropostaZeuss = state?.origem === 'ZEUSS';
  const isPropostaTricard = state?.origem === 'TRICARD';
  const documentosLimiteCredito =
    RequestUserDocuments.data?.documentosLimiteCredito?.filter(
      (documento) => !!documento?.arquivo,
    ) || [];

  useEffect(() => {
    setProposal(proposal);
    setProposalResult(proposalResult);
    setReference(reference?.reference);
    setReferenceII(referenceII?.referenceII);
  }, [proposal, proposalResult, reference, referenceII]);

  useEffect(() => {
    RequestUserDocuments.callApi();
    GETSearchOCRProposal.callApi();
    getOperador();
  }, []);

  useEffect(() => {
    if (operador.length > 0 && !selectedOperadorTransfer) {
      const opName =
        proposalConvenio?.proposta?.atendente?.nomeOperador ||
        proposalSPC?.proposta?.atendente?.nomeOperador;
      if (opName) {
        const found = operador.find(
          (o) => o.value?.toLowerCase() === opName.toLowerCase(),
        );
        if (found) {
          setSelectedOperadorTransfer(found.id);
        }
      }
    }
  }, [operador, proposalConvenio, proposalSPC, selectedOperadorTransfer]);

  useEffect(() => {
    if (reasonRemakeProposal !== 7) {
      setOthersReasonRemakeProposal('');
    }
  }, [reasonRemakeProposal]);

  useEffect(() => {
    if (!dialogRemakeProposalIsOpen) {
      setReasonRemakeProposal(-1);
      setErrorReasonRemakeProposal('');
    }
  }, [dialogRemakeProposalIsOpen]);

  useEffect(() => {
    popula();
  }, [POSTReferenceIIAPI.loading]);

  const handleValidation = () => {
    let errors = [
      emailValidator(proposalT.email),
      socialNameValidator(proposalT.nomeSocial, proposalT.nome),
      // dateValidator(form.dtNascimento?.masked, ValidatorsNames.dateBirth),
      // phoneValidator(form.phone?.masked),
      // defaultValidator(form.cep?.masked, ValidatorsNames.cep, 9),
      // testePipe
    ].reduce((memo, el) => ({ ...memo, ...el }), {});

    if (errors?.socialName) {
      setDialogError(true);
      setDialogErrorMessage(String(errors?.socialName));
      return;
    }

    setValidationErrors(errors);

    const hasErrors = Object.values(errors).filter((a) => a !== null).length;

    if (hasErrors) {
      return false;
    }
    return true;
  };

  const getProposalBySPC = async () => {
    const responseSPC = await RequestProposalSPC.callApi();

    const UF = responseSPC.data.proposta?.endereco?.uf;

    if (responseSPC.status === 200) {
      if (!UF || UF === '' || !STATES.some((a) => a.value === UF)) {
        setValidationErrors((prev) => ({
          ...prev,
          state: 'Selecione um estado',
        }));
      }
      return responseSPC.data;
    }
    return null;
  };

  console.log('pipe');
  const popula = async () => {
    const responseRemakeRanson = await RequestRemakeProposalRanson.callApi();

    if (responseRemakeRanson) {
      const orderedReasons = responseRemakeRanson?.data?.listaMotivosRefazer.sort(
        (a, b) => a.idMotivo - b.idMotivo,
      );
      setRemakeRanson(orderedReasons || []);
    }

    if (state?.origem === 'CONVENIO') {
      const responseConvenio = await RequestProposalConvenio.callApi();

      if (responseConvenio.status >= 200 && responseConvenio.status < 300) {
        setProposalConvenio(
          (responseConvenio.data as unknown) as IResponseProposalConvenio,
        );
        return;
      }
    } else {
      const dataProposalSPC = await getProposalBySPC();

      if (dataProposalSPC) {
        setDiaVenc(dataProposalSPC?.proposta?.diaVencimento);
        setReasons(dataProposalSPC?.proposta?.motivos || []);
        setProposalSPC(dataProposalSPC);
        loadProposalContacts(dataProposalSPC.proposta.contatos || []);
      }
    }
  };

  const isParecerValid = () => {
    if (!parecer.trim().length) {
      setErrors((prev) => ({
        ...prev,
        parecer: 'Por favor informe o parecer.',
      }));

      return false;
    }
    setErrors((prev) => ({
      ...prev,
      parecer: null,
    }));
    return true;
  };

  const isValorLimiteSenffValid = () => {
    if (isSenff || isPropostaTricard) {
      const aux = Number(
        form?.tValorLimiteSenff.replace('.', '').replace(',', '.'),
      );

      if (aux < 250 || aux > 5000) {
        setErrors((prev) => ({
          ...prev,
          valorLimiteSenff: 'Por favor informe um valor.',
        }));

        return false;
      }
      setErrors((prev) => ({
        ...prev,
        valorLimiteSenff: null,
      }));
      return true;
    }
    return true;
  };

  const keepAnalysis = async () => {
    if (!isParecerValid()) return;

    const response = await apiKeepProposal.callApi({ motivo: parecer });

    if (response.status >= 200 && response.status < 300) {
      setDialogMessageStatus(true);
      setDialogMessage('Proposta mantida em análise!');
      setDialogMessageGoBack(true);
    } else if (response.status > 400) {
      setDialogError(true);
      setDialogErrorMessage(
        response.mensagem
          ? response.mensagem
          : 'Não foi possível atender a solicitação',
      );
    }
  };

  const getProposalPayload = (): ProposalComplPayload => {
    const payload: ProposalComplPayload = {
      cliente: {
        celular: proposalSPC.proposta?.celular,
        celular2: proposalSPC.proposta?.celular2,
        cpf: proposalSPC.proposta?.cpf,
        dataNascimento: proposalSPC.proposta?.dataNascimento,
        diaVencimento: diaVenc,
        email: proposalSPC.proposta?.cliente.email,
        endereco: {
          bairro: proposalSPC.proposta?.endereco.bairro,
          cep: proposalSPC.proposta?.endereco.cep,
          cidade: proposalSPC.proposta?.endereco.cidade,
          complemento: proposalSPC.proposta?.endereco.complemento,
          logradouro: proposalSPC.proposta?.endereco.logradouro,
          numero: proposalSPC.proposta?.endereco.numero,
          uf: proposalSPC.proposta?.endereco.uf,
          pais: '',
        },
        genero: proposalSPC.proposta?.cliente.genero,
        limiteCredito: proposalSPC.proposta?.limiteSugerido
          ? Number(proposalSPC.proposta?.limiteSugerido)
          : 0,
        nome: proposalSPC.proposta?.nome,
        nomeSocial: proposalT?.nomeSocial ? proposalT.nomeSocial : '',
        profissao: proposalSPC.proposta?.profissao || '',
        nomeEmpresa: proposalSPC.proposta?.nomeEmpresa || '',
        rendaInformada: proposalSPC.spc?.rendaPresumida
          ? Number(proposalSPC.spc?.rendaPresumida)
          : 0,
      },
      motivo: parecer,
      contaConsumo: proposalSPC?.spc?.contaConsumo
        ? Number(proposalSPC?.spc?.contaConsumo)
        : 0,
      empregoFormal: Boolean(proposalSPC?.proposta?.empregoFormal),
      profissao: proposalSPC?.proposta?.profissao,
      nomeEmpresa: proposalSPC?.proposta?.nomeEmpresa,
      propostaId: state?.id,
      negativacao: Boolean(proposalSPC?.spc?.negativacao),
      rendaPresumida: proposalSPC?.spc?.rendaPresumida
        ? Number(proposalSPC?.spc?.rendaPresumida)
        : 0,
      score: proposalSPC?.spc?.score ? Number(proposalSPC?.spc?.score) : 0,
      rendaInformada: proposalSPC?.spc?.rendaPresumida
        ? Number(proposalSPC?.spc?.rendaPresumida)
        : 0,
      cpfAnalisadoMenosNoventaDias: false,
      certiface: proposalSPC.proposta?.certiface,
      origem: state?.origem,
    };

    return payload;
  };

  const setProposalAPI = async () => {
    proposalT.email = proposalT.email.trim();
    const response = await POSTProposalAPI.callApi(proposalT);

    if (response.status === 200 || response.status === 204) {
      return response;
    }
    return response;
  };

  const setReferenceAPI = async () => {
    const payloadRefI = {
      idContato: referenceT?.id ? referenceT.id : undefined,
      comentario: referenceT?.comentarioRef,
      nome: referenceT?.nomeRefe,
      relacao: referenceT?.relacaoCli,
      telefone: referenceT?.phoneRefe?.unmasked,
    };

    const payloadRefII = {
      idContato: referenceIIT?.id ? referenceIIT.id : undefined,
      comentario: referenceIIT?.comentarioRefII,
      nome: referenceIIT?.nomeRefeII,
      relacao: referenceIIT?.relacaoCliII,
      telefone: referenceIIT?.phoneRefeII?.unmasked,
    };

    if (payloadRefI.nome || payloadRefI.relacao || payloadRefI.telefone) {
      await POSTReferenceAPI.callApi([payloadRefI]);
    }

    if (payloadRefII.nome || payloadRefII.relacao || payloadRefII.telefone) {
      await POSTReferenceIIAPI.callApi([payloadRefII]);
    }
  };
  const [webSocketTimeout, setWebsocketTimeout] = useState(59);

  const [socketConnectionOpen, setSocketConnectionOpen] = useState(false);
  const [waitingSocketResponseModal, setWaitingSocketResponseModal] = useState(
    false,
  );

  const { readyState, lastJsonMessage } = useWebSocket(
    endpoints.register.postWebsocketProposal.replace(
      'PARAM_ID_PROPOSTA',
      state?.id,
    ),
    {},
    socketConnectionOpen,
  );
  useEffect(() => {
    let timer;
    if (socketConnectionOpen) {
      if (webSocketTimeout === 0) {
        const resumeState: IProposalResumeLocationState = {
          status: 'ANALISE',
          origem: state?.origem,
        };
        history.push('/credit-table/proposal/proposal-resume', resumeState);

        return;
      }
      timer = setTimeout(() => {
        setWebsocketTimeout((prev) => prev - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [socketConnectionOpen, webSocketTimeout]);

  useEffect(() => {
    if (readyState === 1 && !!lastJsonMessage) {
      if (lastJsonMessage?.aprovado === 'APROVADA') {
        setWaitingSocketResponseModal(false);

        const isConvenio = state?.origem === 'CONVENIO';
        const resumeState: IProposalResumeLocationState = {
          status: 'APROVADA',
          origem: state?.origem,
          nome: lastJsonMessage?.nomeCliente,
          email: lastJsonMessage?.email,
          vencimento: lastJsonMessage?.diaVencimento,
          ...(isConvenio
            ? {
              limiteAdiantamento: lastJsonMessage?.limiteAdiantamento,
              limiteCesta: lastJsonMessage?.limiteCesta,
            }
            : {
              limiteCompras: lastJsonMessage?.limiteCredito,
              limiteSaque: lastJsonMessage?.limiteSaqueConcedido,
            }),
        };
        history.push('/credit-table/proposal/proposal-resume', resumeState);
      } else {
        setWaitingSocketResponseModal(false);
        setDialogMessage('Proposta reprovada.');
        setDialogMessageStatus(true);
        setDialogMessageGoBack(true);
      }
    }
  }, [lastJsonMessage, readyState]);

  const approveProposal = async () => {
    if (!isParecerValid()) {
      setDialogApproveStatus(false);
      return;
    }
    if (!isValorLimiteSenffValid()) {
      setDialogApproveStatus(false);
      return;
    }

    const payload = getProposalPayload();
    // aqui
    const response = await apiApproveProposal.callApi(payload);

    if (response.data?.aprovado === 'PROCESSANDO') {
      setSocketConnectionOpen(true);
      setWaitingSocketResponseModal(true);
      setDialogApproveStatus(false);
    } else {
      setDialogMessage(response?.data?.mensagem ?? 'Proposta reprovada.');
      setDialogMessageStatus(true);
      setDialogMessageGoBack(true);

      setDialogApproveStatus(false);
    }
  };

  const approveProposalNew = async () => {
    const limiteCredito = Number(
      form?.tValorLimiteSenff.replace('.', '').replace(',', '.'),
    );

    const payload = {
      propostaId: state?.id,
      origem: state?.origem,
      limiteCredito,
      motivo: parecer,
    };
    const response = await POSTCTproposalApproveNew.callApi(payload);

    if (response.data?.aprovado === 'PROCESSANDO') {
      setSocketConnectionOpen(true);
      setWaitingSocketResponseModal(true);
      setDialogApproveStatus(false);
    } else {
      setDialogMessage(response?.data?.mensagem ?? 'Proposta reprovada.');
      setDialogMessageStatus(true);
      setDialogMessageGoBack(true);

      setDialogApproveStatus(false);
    }
  };

  async function refuseProposal() {
    const response = await apiRefuse.callApi({
      motivoStatus: parecer,
    });

    if (response.status === 200 || response.status === 201) {
      setDialogMessage('Proposta recusada com sucesso!');

      setDialogRefuseStatus(false);
      setDialogMessageStatus(true);
      setDialogMessageGoBack(true);
      popula();
    } else if (response.status > 400) {
      setDialogRefuseStatus(false);
      setDialogError(true);
      setDialogErrorMessage(
        response.mensagem
          ? response.mensagem
          : 'Não foi possível atender a solicitação',
      );
    }
  }

  const onClickRefuse = () => {
    if (!isParecerValid()) return;
    setDialogRefuseStatus(true);
  };

  const onClickAprove = () => {
    if (!isValorLimiteSenffValid()) return;
    if (!isParecerValid()) return;
    if (!handleValidation()) {
      setDialogError(true);
      setDialogErrorMessage('O Nome social não pode ser igual ao nome');
    } else {
      setDialogApproveStatus(true);
    }
  };

  const onClickSaveProposal = () => {
    if (!handleValidation()) return;

    if (!handleValidation()) {
      setDialogError(true);
      setDialogErrorMessage(ValidatorsNames.socialName);
      return;
    }

    setDialogIsOpenSave(true);
  };

  const loadProposalContacts = (items: PropostaContatoReferencia[] = []) => {
    let idx = 1;

    addReference(null);
    addReferenceII(null);
    setHasReference(false);

    if (items.length === 0) return;

    items.forEach((i) => {
      if (idx === 1) {
        const newRef: IReference = {
          id: i.id,
          comentarioRef: i.comentario,
          nomeRefe: i.nome,
          phoneRefe: phoneMask(i.telefone),
          relacaoCli: i.relacao,
        };

        const field: IReducers = {
          reference: newRef,
        };

        addReference(field);
        setHasReference(true);
      } else {
        const newRef: IReferenceII = {
          id: i.id,
          comentarioRefII: i.comentario,
          nomeRefeII: i.nome,
          phoneRefeII: phoneMask(i.telefone),
          relacaoCliII: i.relacao,
        };

        const field: IReducers = { referenceII: newRef };

        addReferenceII(field);
        setHasReferenceII(true);
      }

      idx += 1;
    });
  };

  useEffect(() => {
    setUserAuthorized(hasAnyRole(['ADM', 'SUP', 'MDC']));
  }, []);

  const goBack = () => history.goBack();

  const addProposalAPI = async () => {
    const response = await setProposalAPI();

    if (response.status === 200 || response.status === 204) {
      setDialogMessage('Proposta alterada com sucesso!');

      setDialogIsOpenSave(false);
      setDialogMessageStatus(true);
      popula();
    } else {
      setDialogMessage(response?.mensagem || 'Não foi possível salvar!');
      setDialogIsOpenSave(false);
      setDialogMessageStatus(true);
    }
  };

  const addReferenceAPI = async () => {
    await setReferenceAPI();

    setDialogMessage('Referências alterada com sucesso!');

    setDialogIsOpenSaveR(false);
    setDialogMessageStatus(true);
  };

  const closeModalMessage = () => {
    if (dialogMessageGoBack) goBack();
    setDialogMessageStatus(false);
  };

  const certifaceMessage = () => {
    if (!proposalSPC?.proposta?.certiface) return '';

    const approved = proposalSPC?.proposta?.certiface?.resultado === 'APROVADO';

    return (
      <>
        <CertifaceTitle>CERTIFACE: </CertifaceTitle>
        <CertifaceMessage approved={approved}>
          {proposalSPC?.proposta?.certiface?.resultado} -&nbsp;
          {proposalSPC?.proposta?.certiface?.status}
        </CertifaceMessage>
      </>
    );
  };
  const unicoMessage = () => {
    if (!proposalSPC?.proposta?.biometria) return '';

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <UnicoTitle>UNICO: </UnicoTitle>
        <UnicoMessage>
          Comportamento:{' '}
          {proposalSPC.proposta?.biometria?.unico?.resultadoAlertaComportamento}
        </UnicoMessage>
        <UnicoMessage>
          Autenticação:{' '}
          {proposalSPC.proposta?.biometria?.unico?.resultadoAutenticacao}
        </UnicoMessage>
      </div>
    );
  };

  const renderMessage = () => {
    if (proposalSPC?.proposta?.biometria?.unico?.id) {
      return unicoMessage();
    }
    return certifaceMessage();
  };

  const toAssign = async () => {
    const payload = {
      idUsuario: localStorage.getItem(Constants.USER_ID),
    };

    const response = await apiToAssign.callApi(payload);

    if (response.status === 204) {
      setDialogMessageStatus(true);
      setDialogMessage('Proposta atribuída com sucesso!');
      popula();
    } else {
      setDialogErrorMessage(
        response.data.mensagem || 'Ocorreu um erro ao atribuir a proposta!',
      );
      setDialogError(true);
    }
  };

  const toUnassign = async () => {
    const response = await apiToUnassign.callApi();

    if (response.status === 204) {
      setDialogMessageStatus(true);
      setDialogMessage('Proposta desatribuída com sucesso!');
      popula();
    } else {
      setDialogErrorMessage(
        response.data.mensagem || 'Ocorreu um erro ao desatribuir a proposta!',
      );
      setDialogError(true);
    }
  };

  const onClickRemakeProposal = async () => {
    if (
      reasonRemakeProposal === -1 ||
      (reasonRemakeProposal === 7 && othersReasonRemakeProposal === '')
    )
      return setErrorReasonRemakeProposal('Preencha os campos corretamente!');

    const payload = {
      descricaoMotivo: `${
        remakeRanson[reasonRemakeProposal - 1].descricao
      } ${othersReasonRemakeProposal}`,
      idMotivo: remakeRanson[reasonRemakeProposal - 1].idMotivo,
    };

    setErrorReasonRemakeProposal('');

    try {
      const response = await RequestRemakeProposal.callApi(payload);
      if (response.status >= 200 && response.status < 300) {
        setDialogClientSolicitation(true);
        toggleRemakeProposalDialog();
      } else if (response.status > 400) {
        toggleRemakeProposalDialog();
        setDialogError(true);
        setDialogErrorMessage(
          response.mensagem
            ? response.mensagem
            : 'Não foi possivel refazer a proposta',
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelProposal = async (id) => {
    if (!isParecerValid()) return;

    const payload = {
      motivoStatus: parecer,
    };

    try {
      const response = await PUTCancelProposal.callApi(payload);
      if (response.status === 200) {
        setDialogCancelProposalSucess(true);
        setDialogCancelProposal(!dialogCancelProposal);
      } else if (response.status >= 400) {
        setDialogCancelProposal(!dialogCancelProposal);
        setDialogError(true);
        setDialogErrorMessage(
          response.mensagem
            ? response.mensagem
            : 'Não foi possivel cancelar a proposta',
        );
      }
    } catch (error) {
      setDialogMessageStatus(false);
      setDialogError(true);
      setDialogErrorMessage(error.message);
    }
  };

  const toggleRemakeProposalDialog = () =>
    setDialogRemakeProposal((prev) => !prev);

  const showOptionsRule = () => {
    let show = false;

    const idUser = localStorage.getItem(Constants.USER_ID);
    const idOper = proposalSPC.proposta?.operador?.idOperador ?? '';

    userRoles.forEach((i) => {
      if (
        i === Constants.ROLE_ADMIN ||
        i === Constants.ROLE_SUPERVISOR ||
        idUser === idOper
      ) {
        show = true;
      }
    });

    return show;
  };

  const handleTermsConditions = async () => {
    const filePath = Termos.termosCondicoes;

    window.open(filePath);
  };

  const handleTermsPrivacy = async () => {
    const filePath = Termos.termosPrivacidade;

    window.open(filePath);
  };

  const handleChange = ({
    target: { value, name },
  }: React.ChangeEvent<HTMLInputElement>) => {
    setFormState({ target: { value, name } }, form, setForm);
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePictureBiometric = (): string => {
    if (RequestUserDocuments.data?.fotoCertiface) {
      console.log(
        'RequestUserDocuments.data?.fotoCertiface',
        RequestUserDocuments.data?.fotoCertiface,
      );
      return `data:image/png;base64, ${RequestUserDocuments.data?.fotoCertiface}`;
    } else if (
      proposalConvenio?.proposta?.biometria?.unico?.selfieUnico?.urlFoto
    ) {
      return proposalConvenio?.proposta?.biometria?.unico?.selfieUnico?.urlFoto;
    } else {
      return icons.userAvatar;
    }
  };

  return (
    <>
      <Loading
        status={
          apiRefuse.loading ||
          apiApproveProposal.loading ||
          POSTProposalAPI.loading ||
          POSTReferenceAPI.loading ||
          apiKeepProposal.loading ||
          apiToAssign.loading ||
          apiToUnassign.loading ||
          RequestProposalSPC?.loading ||
          RequestRemakeProposal.loading ||
          PUTCancelProposal.loading ||
          RequestProposalConvenio.loading ||
          RequestUserDocuments.loading ||
          RequestPutTransferOperator.loading ||
          RequestGetTransferHistory.loading
        }
      />

      <St.CustomPopup
        nested
        modal
        onClose={() => setWaitingSocketResponseModal(false)}
        open={waitingSocketResponseModal}
        position="center center"
        overlayStyle={{
          background: 'rgba(0, 0, 0, 0.7)',
        }}
        closeOnDocumentClick={false}
        contentStyle={{ background: 'white', width: '30%' }}
      >
        <div className="containerModal">
          <p>Informações foram salvas com sucesso!</p>
          <span>
            Aguarde alguns segundos, estamos finalizando a tua proposta!
          </span>
          <div className="counterContainer">
            <p style={{ position: 'absolute', top: '35%' }}>
              00:
              {webSocketTimeout < 10
                ? `0${webSocketTimeout}`
                : webSocketTimeout}
            </p>
            <St.Loader2>
              <div className="lds-default">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
              </div>
            </St.Loader2>
          </div>
        </div>
      </St.CustomPopup>
      <Dialog
        icon={icons.confirmation}
        open={dialogMessageStatus}
        positiveLabel="Entendi"
        positiveAction={closeModalMessage}
        message={dialogMessage}
      />

      <Dialog
        icon={icons.exclamation}
        open={dialogCancelProposal}
        positiveLabel="SIM"
        positiveAction={() => handleCancelProposal(state.id)}
        message="Deseja mesmo cancelar a proposta?"
        negativeLabel="NÃO"
        negativeAction={() => history.push('/credit-table/proposal')}
      />

      <Dialog
        icon={icons.exclamation}
        open={dialogError}
        positiveLabel="Entendi"
        positiveAction={() => setDialogError(false)}
        message={dialogErrorMessage}
      />

      <Dialog
        icon={icons.confirmation}
        open={dialogCancelProposalSucess}
        positiveLabel="Entendi"
        positiveAction={goBack}
        message="Proposta Cancelada com sucesso"
      />

      <Dialog
        icon={icons.exclamation}
        open={dialogClientSolicitation}
        positiveLabel="Entendi"
        positiveAction={() => {
          setDialogClientSolicitation(false);
          goBack();
        }}
        message="Solicitação enviada ao cliente! Obrigado."
      />

      <Dialog
        Loading={POSTCTproposalApproveNew.loading || apiApproveProposal.loading}
        buttonDisabledPositive={
          POSTCTproposalApproveNew.loading || apiApproveProposal.loading
        }
        icon={icons.confirmation}
        open={dialogApproveStatus}
        negativeLabel="Cancelar"
        negativeAction={() => setDialogApproveStatus(false)}
        positiveLabel="Enviar"
        positiveAction={() => {
          if (isPropostaTricard) {
            approveProposalNew();
            return;
          }
          if (
            state?.origem !== 'LOJA' &&
            state?.origem !== 'APP' &&
            state?.origem !== 'WEB' &&
            state?.origem !== 'ZEUSS'
          ) {
            approveProposalNew();
          } else {
            approveProposal();
          }
        }}
        message="Enviar proposta para análise ?"
      />

      <Dialog
        icon={icons.confirmation}
        open={dialogRefuseStatus}
        negativeLabel="Cancelar"
        negativeAction={() => setDialogRefuseStatus(false)}
        positiveLabel="Recusar"
        positiveAction={refuseProposal}
        message="Você tem certeza que deseja recusar a proposta?"
      />
      <Dialog
        icon={icons.confirmation}
        open={dialogIsOpenSave}
        message="Deseja salvar as alterações, feitas em seus dados pessoais?"
        negativeLabel="Cancelar"
        negativeAction={() => setDialogIsOpenSave(false)}
        positiveLabel="Continuar"
        positiveAction={addProposalAPI}
      />
      <Dialog
        icon={icons.confirmation}
        open={dialogIsOpenSaveR}
        message="Deseja salvar as alterações, das suas referências?"
        negativeLabel="Cancelar"
        negativeAction={() => setDialogIsOpenSaveR(false)}
        positiveLabel="Continuar"
        positiveAction={addReferenceAPI}
      />

      <Dialog
        open={dialogRemakeProposalIsOpen}
        icon={icons.exclamation}
        negativeLabel="Voltar"
        negativeAction={toggleRemakeProposalDialog}
        positiveLabel="Confirmar"
        positiveAction={onClickRemakeProposal}
        title={<span style={{ color: 'red' }}>Refazer proposta</span>}
        widthInPercent={40}
      >
        <>
          <h4>Motivos:</h4>
          {remakeRanson.map((item: IRemakeProposalRansonItem) => (
            <>
              {item.idMotivo !== 7 ? (
                <Checkbox
                  message={item.descricao}
                  onChangeStatus={() => setReasonRemakeProposal(item.idMotivo)}
                  value={reasonRemakeProposal === item.idMotivo}
                  auto={false}
                />
              ) : (
                <ContainerFlex row style={{ maxWidth: 400 }}>
                  <Checkbox
                    message={item.descricao}
                    onChangeStatus={() =>
                      setReasonRemakeProposal(item.idMotivo)
                    }
                    value={reasonRemakeProposal === item.idMotivo}
                    auto={false}
                  />{' '}
                  &nbsp;
                  <Input
                    style={{ marginTop: 25 }}
                    disabled={reasonRemakeProposal !== 7}
                    value={othersReasonRemakeProposal}
                    onChange={(e) => {
                      setOthersReasonRemakeProposal(
                        e.target.value
                          .replace(/[\u0300-\u036f]/g, '')
                          .replace(/[^\w\s]/gi, ''),
                      );
                    }}
                    maxLength={30}
                  />
                </ContainerFlex>
              )}
            </>
          ))}

          <St.ErrorMessage>{errorReasonRemakeProposal}</St.ErrorMessage>
        </>
      </Dialog>

      <Dialog
        open={dialogReasonShow}
        positiveLabel="Fechar"
        widthInPercent={60}
        positiveAction={() => setDialogReasonShow(false)}
      >
        <ContainerFlex center>
          <h2>Motivos</h2>
          <br />
          {reasons.map((item: ProposalReason) => (
            <ContainerFlex row marginBottom={18}>
              <div>
                <strong>CPF: </strong>
                {cpfMask(item.cpf).masked.trim()}
              </div>

              <ItemDialogReasonDivider />

              <div>
                <strong>STATUS: </strong>
                {item.status.trim()}
              </div>

              <ItemDialogReasonDivider />

              <div>
                <strong>DATA: </strong>
                {String(
                  moment(item.dataInclusao).format('DD/MM/YYYY HH:mm'),
                ).trim()}
              </div>

              <ItemDialogReasonDivider />

              <div>
                <strong>MOTIVO: </strong>
                {item.motivoStatus?.trim()}
              </div>
            </ContainerFlex>
          ))}
        </ContainerFlex>
      </Dialog>

      <Dialog
        open={dialogTransferHistoryOpen}
        negativeLabel="Fechar"
        negativeAction={() => setDialogTransferHistoryOpen(false)}
        widthInPercent={90}
      >
        <St.TransferHistoryDialogContent>
          <St.TransferHistoryDialogHeader>
            <St.TransferHistoryDialogIcon src={icons.warning} alt="warning" />
            <St.TransferHistoryDialogTitle>
              HISTÓRICO DE TRANSFERÊNCIA DE PROPOSTA
            </St.TransferHistoryDialogTitle>
          </St.TransferHistoryDialogHeader>

          {transferHistoryLoading ? (
            <ContainerFlex center>
              <Loading />
            </ContainerFlex>
          ) : transferHistoryList.length === 0 ? (
            <ContainerFlex center>
              <Label>Não existe transferências para essa proposta</Label>
            </ContainerFlex>
          ) : (
            <St.TransferHistoryTableWrapper>
              <TableList
                customerHeader={transferHistoryHeader}
                list={transferHistoryList}
              />
            </St.TransferHistoryTableWrapper>
          )}
        </St.TransferHistoryDialogContent>
      </Dialog>

      <Dialog
        open={dialogTransferOpen}
        message="Qual o motivo que deseja transferir a proposta?"
        positiveLabel="Continuar"
        positiveAction={() => {
          setDialogTransferOpen(false);
          setDialogTransferConfirmOpen(true);
        }}
        negativeLabel="Cancelar"
        negativeAction={() => setDialogTransferOpen(false)}
        buttonDisabledPositive={motivo.trim().length <= 3}
      >
        <ContainerFlex center marginTop={20}>
          <ContainerFlex>
            <TextArea
              placeholder="Digite o motivo"
              rows={4}
              name="motivo"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
            />
          </ContainerFlex>
        </ContainerFlex>
      </Dialog>

      <Dialog
        open={dialogTransferConfirmOpen}
        message={`Deseja mesmo transferir a proposta para ${
          operador.find((o) => o.id === selectedOperadorTransfer)?.value || ''
        }?`}
        positiveLabel="SIM"
        positiveAction={() => {
          putTransferOperator();
          setDialogTransferConfirmOpen(false);
        }}
        negativeLabel="NÃO"
        negativeAction={() => setDialogTransferConfirmOpen(false)}
      />

      <Container>
        <St.BoxCard>
          <ContainerFlex>
            <ContainerFlex padding={26}>
              <TitleApp>Análise de Propostas</TitleApp>
            </ContainerFlex>

            <ContainerFlex>
              <Grid xs={1} lg={2}>
                <ContainerFlex>
                  <St.TitleCategory paddingLeft={26}>
                    1. Dados do Cadastro / Proposta
                  </St.TitleCategory>
                  <ProposalResult
                    data={proposalSPC}
                    dataConvenio={proposalConvenio}
                    errors={validationErrors}
                    origem={state?.origem}
                  />
                </ContainerFlex>

                <ContainerFlex>
                  <St.TitleCategory paddingLeft={20}>
                    2. Resultado
                  </St.TitleCategory>
                  <ProposalResultSPC
                    data={proposalSPC}
                    dataConvenio={proposalConvenio}
                    origem={state?.origem}
                  />
                </ContainerFlex>
                <ContainerFlex marginLeft={30} row horizontal wrap>
                  <div>
                    <ContainerFlex row horizontal marginLeft={60}>
                      <St.TitleFileChoose>CNH ou RG</St.TitleFileChoose>
                      <St.TitleFileChooseSmall>
                        (Frente e verso)
                      </St.TitleFileChooseSmall>
                    </ContainerFlex>

                    <ContainerFlex row horizontal>
                      <PictureCard
                        width="150"
                        height="100"
                        showOptions={
                          !!RequestUserDocuments.data?.documentoFrente
                        }
                        src={
                          RequestUserDocuments.data?.documentoFrente
                            ? `data:image/png;base64, ${RequestUserDocuments.data?.documentoFrente}`
                            : icons.tableDocumentFront
                        }
                      />
                      <PictureCard
                        width="150"
                        height="100"
                        showOptions={
                          !!RequestUserDocuments.data?.documentoVerso
                        }
                        src={
                          RequestUserDocuments.data?.documentoVerso
                            ? `data:image/png;base64, ${RequestUserDocuments.data?.documentoVerso}`
                            : icons.tableDocumentBack
                        }
                      />
                    </ContainerFlex>
                    <St.TitleFileChooseSmall>
                      Clique no ícone para selecionar a imagem
                    </St.TitleFileChooseSmall>
                  </div>

                  <ContainerFlex marginLeft={20}>
                    <ContainerFlex row horizontal marginLeft={40}>
                      <St.TitleFileChoose>
                        {state?.origem === 'CONVENIO' ? 'Unico' : 'Certiface'}
                      </St.TitleFileChoose>
                    </ContainerFlex>

                    <ContainerFlex row horizontal>
                      <PictureCard
                        width="150"
                        height="100"
                        showOptions={!!RequestUserDocuments.data?.fotoCertiface}
                        src={handlePictureBiometric()}
                      />
                    </ContainerFlex>

                    <St.TitleFileChooseSmall>
                      Clique no ícone para selecionar a imagem
                    </St.TitleFileChooseSmall>
                  </ContainerFlex>
                </ContainerFlex>
              </Grid>
            </ContainerFlex>
            <St.TitleCategory paddingLeft={26}>OCR</St.TitleCategory>

            <ContainerFlex padding={26}>
              {!GETSearchOCRProposal.error ? (
                <TableOCR data={GETSearchOCRProposal?.data?.campos} />
              ) : (
                <ContainerFlex center>
                  <St.TitleCategory>
                    {'Não há dados de OCR para este cliente'}
                  </St.TitleCategory>
                </ContainerFlex>
              )}
            </ContainerFlex>
            <CardView>
              <ContainerFlex row end padding={15}>
                {proposalSPC.status?.includes(ProposalStatus.ANALISE) && (
                  <Button
                    marginLeft={16}
                    onClick={onClickSaveProposal}
                    loading={
                      apiRefuse.loading ||
                      POSTProposalAPI.loading ||
                      POSTReferenceAPI.loading
                    }
                  >
                    Salvar
                  </Button>
                )}
              </ContainerFlex>
            </CardView>

            {state?.origem !== 'CONVENIO' && (
              <>
                <St.TitleCategory paddingLeft={26}>
                  3. Referências Pessoais
                </St.TitleCategory>

                <ContainerFlex padding={26}>
                  <Grid xs={1} lg={2}>
                    <ContainerFlex>
                      <St.TitleCategory>Referência I</St.TitleCategory>
                      <br />
                      <ProposalReference hasReference={hasReference} />
                    </ContainerFlex>

                    <ContainerFlex>
                      <St.TitleCategory paddingLeft={10}>
                        Referência II
                      </St.TitleCategory>
                      <br />
                      <ProposalReferenceII hasReference={hasReferenceII} />
                    </ContainerFlex>
                  </Grid>
                </ContainerFlex>
                <CardView>
                  <ContainerFlex row end padding={15}>
                    {proposalSPC.status?.includes(ProposalStatus.ANALISE) && (
                      <Button
                        marginLeft={16}
                        onClick={() => setDialogIsOpenSaveR(true)}
                        loading={
                          apiRefuse.loading ||
                          POSTProposalAPI.loading ||
                          POSTReferenceAPI.loading
                        }
                      >
                        Salvar
                      </Button>
                    )}
                  </ContainerFlex>
                </CardView>
              </>
            )}

            <St.TitleCategory paddingLeft={26}>
              {`${
                state?.origem !== 'CONVENIO' ? '4' : '3'
              }. Proposta de Crédito`}
            </St.TitleCategory>

            <ContainerFlex padding={26}>
              <Grid xs={1} lg={2} gap={30}>
                <ContainerFlex>
                  <Input
                    label="ID da proposta"
                    value={
                      proposalSPC?.idProposta ||
                      proposalConvenio?.proposta?.id ||
                      ''
                    }
                  />
                  {state?.origem !== 'CONVENIO' ? (
                    <>
                      <Input
                        label="Restrição"
                        value={
                          // eslint-disable-next-line no-nested-ternary
                          proposalSPC?.spc
                            ? proposalSPC?.spc.negativacao
                              ? 'Sim'
                              : 'Não'
                            : ''
                        }
                      />
                      <Input
                        label="Score"
                        value={
                          proposalSPC?.spc?.score
                            ? String(proposalSPC?.spc.score)
                            : ''
                        }
                      />
                    </>
                  ) : (
                    <Input
                      label="Informação profissional"
                      value={'Informação profissional não disponível'}
                    />
                  )}
                  <Input
                    label="Limite sugerido pelo motor"
                    value={
                      proposalConvenio?.proposta?.limiteSugerido
                        ? currencyMask(
                            proposalConvenio?.proposta?.limiteSugerido,
                          )
                        : isSenff || isPropostaTricard
                        ? 0
                        : currencyMask(proposalSPC?.proposta?.limiteSugerido)
                    }
                  />
                  <ContainerFlex>
                    <span style={{ fontSize: '12px', color: '#757575' }}>
                      Optin
                    </span>
                    <Checkbox
                      value={
                        proposalSPC?.proposta?.optinTermoDeUso ||
                        proposalConvenio?.proposta?.optinTermoDeUso
                      }
                      terms={
                        <>
                          Li e concordo com os
                          <St.ViewTerms onClick={handleTermsConditions}>
                            Termos e condições de uso
                          </St.ViewTerms>
                          e a
                          <St.ViewTerms onClick={handleTermsPrivacy}>
                            Política de privacidade
                          </St.ViewTerms>
                        </>
                      }
                      readonly
                    />
                    <Checkbox
                      terms="Desejo receber comunicação do meu interesse por WhatsApp"
                      value={
                        proposalSPC?.proposta?.checkWhatsApp ||
                        proposalConvenio?.proposta?.checkWhatsApp
                      }
                      readonly
                    />
                  </ContainerFlex>
                </ContainerFlex>

                <ContainerFlex>
                  <Input
                    label="Dia vencimento da fatura"
                    value={diaVenc}
                    maxLength={2}
                    onChange={(e) => setDiaVenc(e.target.value)}
                  />
                  {state.origem !== 'CONVENIO' && (
                    <Input
                      label="Valor da restrição"
                      value={
                        proposalSPC?.spc
                          ? currencyMask(proposalSPC?.spc.valorRestricao)
                          : ''
                      }
                    />
                  )}
                  <Input
                    label="Canal"
                    value={state?.origem ? state?.origem : ''}
                  />

                  <div>
                    <Grid xs={1} lg={2} gap={10}>
                      <ContainerFlex>
                        <Input
                          label="Loja"
                          value={
                            proposalConvenio?.proposta?.loja?.nome
                              ? proposalConvenio?.proposta?.loja?.nome
                              : proposalSPC.proposta
                              ? isSenff || isPropostaZeuss || isPropostaTricard
                                ? proposalSPC?.proposta?.empresa
                                : state.origem !== 'LOJA'
                                ? state.origem
                                : proposalSPC?.proposta.empresa
                              : ''
                          }
                        />
                      </ContainerFlex>

                      <ContainerFlex>
                        <Input
                          label="Operador(a) de Venda"
                          value={
                            proposalConvenio?.proposta?.atendente?.nomeOperador
                              ? proposalConvenio?.proposta?.atendente
                                  ?.nomeOperador
                              : proposalSPC?.spc
                              ? proposalSPC?.proposta?.atendente
                                  ?.nomeOperador ||
                                state.origem ||
                                ''
                              : ''
                          }
                        />
                      </ContainerFlex>
                    </Grid>

                    {state.origem !== 'CONVENIO' && (
                      <>
                        <Grid xs={1} lg={2} gap={10}>
                          <ContainerFlex>
                            <Input
                              label="Origem Optin"
                              value={
                                proposalSPC?.spc
                                  ? isSenff ||
                                    isPropostaZeuss ||
                                    isPropostaTricard
                                    ? proposalSPC.proposta.empresa
                                    : state.origem !== 'LOJA'
                                    ? state.origem
                                    : proposalSPC?.proposta.empresa
                                  : ''
                              }
                            />
                          </ContainerFlex>

                          <ContainerFlex>
                            <Input
                              label="Data e Horário Optin"
                              value={
                                proposalSPC?.spc
                                  ? moment(
                                      proposalSPC.proposta?.dataInclusao,
                                    ).format('DD/MM/YYYY HH:mm:ss')
                                  : ''
                              }
                            />
                          </ContainerFlex>
                        </Grid>
                        {userAuthorized &&
                          state?.status?.includes(
                            ProposalStatus.APROVADA_P1,
                          ) && (
                            <ContainerFlex
                              marginTop={10}
                              align="center"
                              style={{ width: '100%' }}
                            >
                              <Grid
                                xs={1}
                                lg={2}
                                gap={15}
                                style={{ width: '100%', alignItems: 'center' }}
                              >
                                <ContainerFlex>
                                  <Select
                                    label="Operador (a) de Venda"
                                    options={operador}
                                    value={selectedOperadorTransfer}
                                    onChange={(e) =>
                                      setSelectedOperadorTransfer(e)
                                    }
                                  />
                                </ContainerFlex>

                                <ContainerFlex
                                  row
                                  gap="12"
                                  marginTop={8}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Button
                                    minimal
                                    fitContent
                                    variant="ghost"
                                    onClick={() => setDialogTransferOpen(true)}
                                    icon={
                                      <IoDownloadOutline
                                        size={20}
                                        color="#000"
                                      />
                                    }
                                    style={{ height: '40px' }}
                                  />

                                  <Button
                                    fitContent
                                    style={{ height: '40px' }}
                                    onClick={() =>
                                      setDialogTransferHistoryOpen(true)
                                    }
                                  >
                                    HISTÓRICO
                                  </Button>
                                </ContainerFlex>
                              </Grid>
                            </ContainerFlex>
                          )}
                      </>
                    )}
                  </div>
                </ContainerFlex>
              </Grid>
            </ContainerFlex>

            {isPropostaZeuss ? (
              <>
                <St.TitleCategory paddingLeft={26}>5. Zeuss</St.TitleCategory>

                <ContainerFlex padding={26}>
                  <Grid xs={1} lg={2} gap={30}>
                    <ContainerFlex>
                      <ContainerFlex row>
                        <Input
                          label="Limite aplicado na proposta:"
                          name="tValorLimiteZeuss"
                          mask={MaskTypes.CURRENCY}
                          value={`R$ ${currencyMask(
                            proposalSPC.proposta?.limiteSugerido,
                          )}`}
                          onChange={() => {}}
                          disabled
                        />
                      </ContainerFlex>
                    </ContainerFlex>
                  </Grid>
                </ContainerFlex>
              </>
            ) : null}

            {isPropostaTricard && (
              <ContainerFlex>
                <St.TitleCategory paddingLeft={26}>5. Tricard</St.TitleCategory>

                <ContainerFlex marginLeft={20} marginBottom={102}>
                  <ContainerFlex
                    row
                    horizontal
                    marginLeft={20}
                    align="flex-end"
                  >
                    <p style={{ marginBottom: '20px' }}>Limite de Crédito</p>
                  </ContainerFlex>

                  <ContainerFlex row horizontal wrap gap="16">
                    {documentosLimiteCredito.length > 0 ? (
                      documentosLimiteCredito.map((documento) => (
                        <PictureCard
                          key={documento.idArquivo}
                          width="200"
                          height="140"
                          showOptions
                          src={`data:image/png;base64, ${documento.arquivo}`}
                        />
                      ))
                    ) : (
                      <PictureCard
                        width="200"
                        height="140"
                        showOptions={
                          !!RequestUserDocuments.data?.documentoLimiteCredito
                        }
                        src={
                          RequestUserDocuments.data?.documentoLimiteCredito
                            ? `data:image/png;base64, ${RequestUserDocuments.data?.documentoLimiteCredito}`
                            : icons.userAvatar
                        }
                      />
                    )}
                  </ContainerFlex>

                  <ContainerFlex maxWidth={75} marginTop={5}>
                    <Input
                      label="Limite aplicado na proposta:"
                      name="tValorLimiteSenff"
                      mask={MaskTypes.CURRENCY}
                      value={
                        proposalSPC.status === 'APROVADA'
                          ? currencyMask(proposalSPC?.proposta?.limiteSugerido)
                          : String(form.tValorLimiteSenff)
                      }
                      onChange={handleChange}
                      edit
                      disabled={proposalSPC.status === 'APROVADA'}
                      errorMessage={errors?.valorLimiteSenff}
                    />
                    <St.TextInfoSenff>
                      *Limite mínimo de R$ 250,00 e máximo de R$ 5.000,00
                    </St.TextInfoSenff>
                  </ContainerFlex>
                </ContainerFlex>
              </ContainerFlex>
            )}

            {state?.origem !== 'CONVENIO' ? (
              <ContainerFlex padding={26}>
                <Grid xs={1} lg={2} gap={30}>
                  <ContainerFlex>
                    <St.TitleCategory paddingLeft={26}>
                      {isPropostaZeuss || isPropostaTricard
                        ? '6. Decisão'
                        : '5. Decisão'}
                    </St.TitleCategory>

                    {reasons && reasons.length > 0 && (
                      <ContainerFlex marginLeft={22}>
                        {reasons.length > 1 ? (
                          <ContainerFlex row center>
                            <ReasonDialogItem
                              item={reasons[reasons.length - 1]}
                            />

                            <Button
                              marginLeft={22}
                              fitContent
                              onClick={() => setDialogReasonShow(true)}
                            >
                              Ver mais
                            </Button>
                          </ContainerFlex>
                        ) : (
                          reasons.length === 1 && (
                            <ReasonDialogItem
                              item={reasons[reasons.length - 1]}
                            />
                          )
                        )}
                      </ContainerFlex>
                    )}

                    <ContainerFlex>
                      <ContainerFlex row marginLeft={22}>
                        {renderMessage()}
                      </ContainerFlex>

                      <ContainerFlex row marginLeft={22}>
                        <CertifaceTitle>SCORE B2E:</CertifaceTitle>
                        <CertifaceMessage approved>
                          {
                            proposalSPC.proposta?.prevencaoFraudeResponse
                              ?.pontuacao
                          }
                        </CertifaceMessage>
                      </ContainerFlex>

                      <ContainerFlex row marginLeft={22}>
                        <CertifaceTitle>SUGESTÃO B2E:</CertifaceTitle>
                        <CertifaceMessage approved>
                          {
                            proposalSPC.proposta?.prevencaoFraudeResponse
                              ?.sugestao
                          }
                        </CertifaceMessage>
                      </ContainerFlex>
                      <ContainerFlex row marginLeft={22}>
                        <CertifaceTitle>SITUAÇÃO SPC:</CertifaceTitle>
                        <CertifaceMessage
                          approved={proposalSPC.spc?.validadoSpc === true}
                        >
                          {proposalSPC.spc?.validadoSpc === true
                            ? 'CPF validado'
                            : 'CPF não foi validado'}
                        </CertifaceMessage>
                      </ContainerFlex>

                      {proposalSPC.proposta?.faceMatchCheckResponse && (
                        <ContainerFlex row marginLeft={22}>
                          <CertifaceTitle>FACEDOC:</CertifaceTitle>
                          <CertifaceMessage
                            approved={
                              proposalSPC.proposta?.faceMatchCheckResponse
                                ?.status === 'REPROVADO' ||
                              proposalSPC.proposta?.faceMatchCheckResponse
                                ?.status === 'FALHOU'
                                ? false
                                : true
                            }
                            ignored={
                              proposalSPC.proposta?.faceMatchCheckResponse
                                ?.forceFaceMatch === true
                            }
                          >
                            {proposalSPC.proposta?.faceMatchCheckResponse
                              ?.status === 'FALHOU' &&
                            proposalSPC.proposta?.faceMatchCheckResponse
                              ?.forceFaceMatch
                              ? 'IGNORADO'
                              : proposalSPC.proposta?.faceMatchCheckResponse
                                  ?.status ||
                                (proposalSPC.proposta?.faceMatchCheckResponse
                                  ?.forceFaceMatch &&
                                  'IGNORADO')}
                          </CertifaceMessage>
                        </ContainerFlex>
                      )}
                    </ContainerFlex>
                  </ContainerFlex>

                  {isSenff && (
                    <ContainerFlex>
                      <St.TitleCategory paddingLeft={26}>
                        6. Senff
                      </St.TitleCategory>

                      <ContainerFlex marginLeft={20} marginBottom={102}>
                        <ContainerFlex
                          row
                          horizontal
                          marginLeft={20}
                          align="flex-end"
                        >
                          <p style={{ marginBottom: '20px' }}>
                            Limite de Crédito
                          </p>
                        </ContainerFlex>

                        <ContainerFlex row horizontal>
                          <PictureCard
                            width="200"
                            height="140"
                            showOptions={
                              !!RequestUserDocuments.data
                                ?.documentoLimiteCredito
                            }
                            src={
                              RequestUserDocuments.data?.documentoLimiteCredito
                                ? `data:image/png;base64, ${RequestUserDocuments.data?.documentoLimiteCredito}`
                                : icons.userAvatar
                            }
                          />
                        </ContainerFlex>

                        <ContainerFlex maxWidth={75} marginTop={5}>
                          <Input
                            label="Limite aplicado na proposta:"
                            name="tValorLimiteSenff"
                            mask={MaskTypes.CURRENCY}
                            value={
                              proposalSPC.status === 'APROVADA'
                                ? currencyMask(
                                    proposalSPC?.proposta?.limiteSugerido,
                                  )
                                : String(form.tValorLimiteSenff)
                            }
                            onChange={handleChange}
                            edit
                            disabled={proposalSPC.status === 'APROVADA'}
                            errorMessage={errors?.valorLimiteSenff}
                          />
                          <St.TextInfoSenff>
                            *Limite mínimo de R$ 250,00 e máximo de R$ 5.000,00
                          </St.TextInfoSenff>
                        </ContainerFlex>
                      </ContainerFlex>
                    </ContainerFlex>
                  )}
                </Grid>
              </ContainerFlex>
            ) : (
              <ContainerFlex padding={26}>
                <Grid xs={1} lg={2} gap={30}>
                  <ContainerFlex>
                    <St.TitleCategory paddingLeft={26}>
                      4. Decisão
                    </St.TitleCategory>

                    {reasons && reasons.length > 0 && (
                      <ContainerFlex marginLeft={22}>
                        {reasons.length > 1 ? (
                          <ContainerFlex row center>
                            <ReasonDialogItem
                              item={reasons[reasons.length - 1]}
                            />

                            <Button
                              marginLeft={22}
                              fitContent
                              onClick={() => setDialogReasonShow(true)}
                            >
                              Ver mais
                            </Button>
                          </ContainerFlex>
                        ) : (
                          reasons.length === 1 && (
                            <ReasonDialogItem
                              item={reasons[reasons.length - 1]}
                            />
                          )
                        )}
                      </ContainerFlex>
                    )}

                    <ContainerFlex>
                      <ContainerFlex marginLeft={22}>
                        <UnicoTitle>UNICO:</UnicoTitle>

                        <UnicoMessage>
                          Comportamento:{' '}
                          {
                            proposalConvenio.proposta?.biometria?.unico
                              ?.resultadoAlertaComportamento
                          }
                        </UnicoMessage>
                        <UnicoMessage>
                          Autenticação:{' '}
                          {
                            proposalConvenio.proposta?.biometria?.unico
                              ?.resultadoAutenticacao
                          }
                        </UnicoMessage>
                      </ContainerFlex>

                      {state.origem !== 'CONVENIO' && (
                        <>
                          <ContainerFlex row marginLeft={22}>
                            <CertifaceTitle>SCORE B2E:</CertifaceTitle>
                            <CertifaceMessage approved>
                              {
                                proposalSPC.proposta?.prevencaoFraudeResponse
                                  ?.pontuacao
                              }
                            </CertifaceMessage>
                          </ContainerFlex>

                          <ContainerFlex row marginLeft={22}>
                            <CertifaceTitle>SUGESTÃO B2E:</CertifaceTitle>
                            <CertifaceMessage approved>
                              {
                                proposalSPC.proposta?.prevencaoFraudeResponse
                                  ?.sugestao
                              }
                            </CertifaceMessage>
                          </ContainerFlex>

                          <ContainerFlex row marginLeft={22}>
                            <CertifaceTitle>SITUAÇÃO SPC:</CertifaceTitle>
                            <CertifaceMessage
                              approved={proposalSPC.spc?.validadoSpc === true}
                            >
                              {proposalSPC.spc?.validadoSpc === true
                                ? 'CPF validado'
                                : 'CPF não foi validado'}
                            </CertifaceMessage>
                          </ContainerFlex>

                          {proposalSPC.proposta?.faceMatchCheckResponse && (
                            <ContainerFlex row marginLeft={22}>
                              <CertifaceTitle>FACEDOC:</CertifaceTitle>
                              <CertifaceMessage
                                approved={
                                  proposalSPC.proposta?.faceMatchCheckResponse
                                    ?.status === 'REPROVADO' ||
                                  proposalSPC.proposta?.faceMatchCheckResponse
                                    ?.status === 'FALHOU'
                                    ? false
                                    : true
                                }
                                ignored={
                                  proposalSPC.proposta?.faceMatchCheckResponse
                                    ?.forceFaceMatch === true
                                }
                              >
                                {proposalSPC.proposta?.faceMatchCheckResponse
                                  ?.status === 'FALHOU' &&
                                proposalSPC.proposta?.faceMatchCheckResponse
                                  ?.forceFaceMatch
                                  ? 'IGNORADO'
                                  : proposalSPC.proposta?.faceMatchCheckResponse
                                      ?.status ||
                                    (proposalSPC.proposta
                                      ?.faceMatchCheckResponse
                                      ?.forceFaceMatch &&
                                      'IGNORADO')}
                              </CertifaceMessage>
                            </ContainerFlex>
                          )}
                        </>
                      )}
                    </ContainerFlex>
                  </ContainerFlex>

                  {isSenff && (
                    <ContainerFlex>
                      <St.TitleCategory paddingLeft={26}>
                        6. Senff
                      </St.TitleCategory>

                      <ContainerFlex marginLeft={20} marginBottom={102}>
                        <ContainerFlex
                          row
                          horizontal
                          marginLeft={20}
                          align="flex-end"
                        >
                          <p style={{ marginBottom: '20px' }}>
                            Limite de Crédito
                          </p>
                        </ContainerFlex>

                        <ContainerFlex row horizontal>
                          <PictureCard
                            width="200"
                            height="140"
                            showOptions={
                              !!RequestUserDocuments.data
                                ?.documentoLimiteCredito
                            }
                            src={
                              RequestUserDocuments.data?.documentoLimiteCredito
                                ? `data:image/png;base64, ${RequestUserDocuments.data?.documentoLimiteCredito}`
                                : icons.userAvatar
                            }
                          />
                        </ContainerFlex>

                        <ContainerFlex maxWidth={75} marginTop={5}>
                          <Input
                            label="Limite aplicado na proposta:"
                            name="tValorLimiteSenff"
                            mask={MaskTypes.CURRENCY}
                            value={
                              proposalSPC.status === 'APROVADA'
                                ? currencyMask(
                                    proposalSPC?.proposta?.limiteSugerido,
                                  )
                                : String(form.tValorLimiteSenff)
                            }
                            onChange={handleChange}
                            edit
                            disabled={proposalSPC.status === 'APROVADA'}
                            errorMessage={errors?.valorLimiteSenff}
                          />
                          <St.TextInfoSenff>
                            *Limite mínimo de R$ 250,00 e máximo de R$ 5.000,00
                          </St.TextInfoSenff>
                        </ContainerFlex>
                      </ContainerFlex>
                    </ContainerFlex>
                  )}
                </Grid>
              </ContainerFlex>
            )}

            <ContainerFlex padding={26}>
              <TextArea
                placeholder="Digitar parecer.."
                rows={10}
                value={parecer}
                onChange={(e) => setParecer(e.target.value)}
                errorMessage={errors.parecer}
              />
            </ContainerFlex>

            {proposalSPC.status?.includes(ProposalStatus.PROCESSANDO) ||
            proposalConvenio.status?.includes(ProposalStatus.PROCESSANDO) ? (
              <ContainerFlex row end wrap padding={24}>
                <Button marginLeft={16} marginBottom={15} onClick={goBack}>
                  Voltar
                </Button>
              </ContainerFlex>
            ) : (
              <ContainerFlex row end wrap padding={24}>
                {userAuthorized && (
                  <>
                    {(proposalSPC.status?.includes(
                      ProposalStatus.PENDENTE ||
                        ProposalStatus.PENDENTE_ANALISE ||
                        ProposalStatus.PENDENTE_MESA,
                    ) ||
                      proposalConvenio.status?.includes(
                        ProposalStatus.PENDENTE ||
                          ProposalStatus.PENDENTE_ANALISE ||
                          ProposalStatus.PENDENTE_MESA,
                      )) && (
                      <Button
                        outlined
                        marginBottom={15}
                        onClick={toAssign}
                        loading={apiToAssign.loading}
                        disabled={apiToAssign.loading}
                      >
                        Atribuir
                      </Button>
                    )}
                  </>
                )}

                {(proposalSPC.status?.includes(
                  ProposalStatus.ANALISE || ProposalStatus.ANALISE_MESA_CREDITO,
                ) ||
                  proposalConvenio?.status?.includes(
                    ProposalStatus.ANALISE ||
                      ProposalStatus.ANALISE_MESA_CREDITO,
                  )) &&
                  userAuthorized && (
                    <Button
                      outlined
                      marginBottom={15}
                      onClick={toUnassign}
                      loading={apiToUnassign.loading}
                      disabled={apiToUnassign.loading}
                    >
                      Desatribuir
                    </Button>
                  )}

                {(proposalSPC.status?.includes(ProposalStatus.ANALISE) ||
                  (proposalConvenio?.status?.includes(ProposalStatus.ANALISE) &&
                    showOptionsRule())) &&
                  userAuthorized && (
                    <Button
                      outlined
                      marginBottom={15}
                      marginLeft={16}
                      onClick={onClickRefuse}
                      loading={apiRefuse.loading}
                      disabled={apiRefuse.loading}
                    >
                      Recusar
                    </Button>
                  )}

                {proposalSPC.status?.includes(ProposalStatus.ANALISE) &&
                  state?.origem !== 'CONVENIO' &&
                  showOptionsRule() &&
                  userAuthorized && (
                    <Button
                      marginLeft={16}
                      marginBottom={15}
                      onClick={toggleRemakeProposalDialog}
                      loading={RequestRemakeProposal.loading}
                      disabled={RequestRemakeProposal.loading}
                    >
                      Refazer Proposta
                    </Button>
                  )}
                <br />

                {(proposalSPC.status?.includes(ProposalStatus.ANALISE) ||
                  (proposalConvenio?.status?.includes(ProposalStatus.ANALISE) &&
                    showOptionsRule())) &&
                  userAuthorized && (
                    <Button
                      marginLeft={16}
                      marginBottom={15}
                      onClick={keepAnalysis}
                      loading={apiKeepProposal.loading}
                      disabled={apiKeepProposal.loading}
                    >
                      Manter em Análise
                    </Button>
                  )}
                <br />

                {(proposalSPC.status?.includes(ProposalStatus.ANALISE) ||
                  (proposalConvenio?.status?.includes(ProposalStatus.ANALISE) &&
                    showOptionsRule())) &&
                  userAuthorized && (
                    <Button
                      marginLeft={16}
                      marginBottom={15}
                      onClick={onClickAprove}
                      loading={apiApproveProposal.loading}
                      disabled={apiApproveProposal.loading}
                    >
                      Analisar
                    </Button>
                  )}

                {userAuthorized && (
                  <Button
                    outlined
                    marginLeft={16}
                    marginBottom={15}
                    onClick={() => setDialogCancelProposal(true)}
                    disabled={!parecer}
                  >
                    Cancelar Proposta
                  </Button>
                )}

                <Button marginLeft={16} marginBottom={15} onClick={goBack}>
                  Voltar
                </Button>
              </ContainerFlex>
            )}
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </>
  );
};

export default DetailProposalCT;
